import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Message box with the tools inside it and today's Send button
 * (Material "send", space_bg_secondary / space_font_secondary, 15px radius).
 * The parent projects its own <textarea> (so the inherited messageInput /
 * threadMessageInput queries keep working) and calls the inherited handlers.
 */
@Component({
  selector: 'app-cm-composer',
  template: `
    <div class="cm-box" [class.disabled]="!signedIn">
      <emoji-mart *ngIf="showEmoji" class="cm-emoji" [showPreview]="false" [isNative]="true" [set]="'native'"
        [enableSearch]="false" [showSingleCategory]="false" (emojiClick)="emojiPick.emit($event)"></emoji-mart>
      <ng-content select="label"></ng-content>
      <ng-content select="textarea"></ng-content>
      <div class="cm-files" *ngIf="files?.length">
        <span class="cm-file" *ngFor="let f of files; let i = index" [title]="f.name">
          {{ f.name }}
          <button type="button" (click)="removeFile.emit(i)" [attr.aria-label]="'Remove ' + f.name"><mat-icon>close</mat-icon></button>
        </span>
      </div>
      <div class="cm-bar">
        <button type="button" class="cm-tool" title="Attach files" aria-label="Attach files" [disabled]="!signedIn"
          (click)="fileInput.click()"><mat-icon>attach_file</mat-icon></button>
        <input #fileInput type="file" multiple hidden (change)="filesSelected.emit($event)" />
        <button type="button" class="cm-tool emoji-input" title="Emoji" aria-label="Emoji" (click)="emojiToggle.emit()">
          <mat-icon class="emoji-input">sentiment_satisfied</mat-icon></button>
        <button type="button" class="cm-tool" *ngIf="showPoll" title="Poll" aria-label="Create poll" (click)="poll.emit()">
          <mat-icon>bar_chart</mat-icon></button>
        <button type="button" class="cm-tool" *ngIf="showTips" title="Tips" aria-label="Send a tip" (click)="tip.emit()">
          <mat-icon>paid</mat-icon></button>
        <button type="button" class="cm-send" title="Send" aria-label="Send" [style.cursor]="signedIn ? 'pointer' : 'not-allowed'"
          (click)="send.emit()"><mat-icon class="notranslate">send</mat-icon></button>
      </div>
    </div>
  `,
  styleUrls: ['./cm-composer.component.scss'],
})
 // <span class="cm-hint">Enter to send · Shift+Enter for a new line</span>
export class CmComposerComponent {
  @Input() files: any[] = [];
  @Input() signedIn = true;
  @Input() showEmoji = false;
  @Input() showPoll = false;
  @Input() showTips = false;

  @Output() send = new EventEmitter<void>();
  @Output() filesSelected = new EventEmitter<Event>();
  @Output() removeFile = new EventEmitter<number>();
  @Output() emojiToggle = new EventEmitter<void>();
  @Output() emojiPick = new EventEmitter<any>();
  @Output() poll = new EventEmitter<void>();
  @Output() tip = new EventEmitter<void>();
}
